import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppColor } from '../../shared/color/color';
import { StringUtils } from '../../shared/utils/string-utils';

@Component({
  selector: 'app-text-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './text-icon.component.html',
  styleUrl: './text-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextIconComponent {
  Color = AppColor;

  constructor() {}

  @Input() name: string = '';
  @Input() size = 24;
  @Input() backgroundColor?: string;

  ngOnInit() {}

  styleForContainer(): CSSStyleDeclaration {
    const style = {} as CSSStyleDeclaration;
    style.borderRadius = '5px';
    style.backgroundColor = this.backgroundColor ?? AppColor.orange;
    style.color = 'white';

    style.width = `${this.size}px`;
    style.height = `${this.size}px`;
    return style;
  }

  sizeForContainer(): string {
    return '24px';
  }

  sizeForEmojiIcon(): string {
    return '20px';
  }

  sizeForText(): string {
    return '20px';
  }

  isEmoji() {
    return StringUtils.isEmoji(StringUtils.getFirstChar(this.name));
  }

  textOrEmoji(): string {
    return StringUtils.getTextIcon(this.name);
  }
}
